export default __webpack_public_path__ + "static/DF_2016-384d740a39f3920f0e252d133af6eb60.pdf";